module.exports = __webpack_public_path__ + "img/avatar-1.1ba7e20f.png";